import { useState, useEffect } from "react";
import { apiGet } from "../lib/api";
import { SartellLogo } from "../components/Logo";
import { TeamBadge } from "../components/TeamBadge";

/* ───────────────────── TEAM SELECT SCREEN ───────────────────── */
export function TeamSelect({ onSelect, onAdmin, magicError }) {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    apiGet("/teams")
      .then((data) => { setTeams(data.teams || []); setLoading(false); })
      .catch((e) => { setError(e.message); setLoading(false); });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <SartellLogo size="lg" />
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-1 text-center">Select Your Team</h2>
          <p className="text-sm text-gray-500 text-center mb-6">Choose your player's team to continue</p>

          {magicError && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3 mb-4 text-center">{magicError}</div>
          )}

          {loading && <p className="text-center text-gray-400 py-8">Loading teams...</p>}
          {error && <p className="text-center text-red-500 py-4">{error}</p>}

          {!loading && teams.length === 0 && !error && (
            <div className="text-center py-8">
              <p className="text-gray-400">No teams set up yet.</p>
              <p className="mt-1 text-sm text-gray-400">
                Ask your coach or club admin for your team's link.
              </p>
              {onAdmin && (
                <button
                  onClick={onAdmin}
                  className="mt-3 text-sm font-semibold text-blue-600 hover:text-blue-800"
                >
                  Are you the admin? Set up your first team →
                </button>
              )}
            </div>
          )}

          <div className="space-y-2">
            {teams.map((t) => (
              <button
                key={t.id}
                onClick={() => onSelect(t)}
                className="w-full flex items-center gap-3 p-4 rounded-xl border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group"
              >
                <TeamBadge team={t} size="md" />
                <div className="flex-1">
                  <div className="font-semibold text-gray-800">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.ageGroup}{t.ageGroup && " · "}{t.season}</div>
                </div>
                <svg className="w-5 h-5 text-gray-300 group-hover:text-blue-600 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            ))}
          </div>

          {!loading && (
            <button
              onClick={() => onAdmin && onAdmin()}
              className="w-full mt-4 py-2 text-xs text-gray-400 hover:text-blue-700 transition-colors"
            >
              Admin Panel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
